module.exports = __webpack_public_path__ + "img/d745730ed36581a93dd4cea6f7088ff1.png";